import { useRouter } from 'next/navigation';

import { useAnalytics } from '@domain/analytics/AnalyticsContext';
import { trackNavigation } from '@domain/analytics/analytics';
import { trackEvent } from '@domain/analytics/trackEvent';
import { reportMykissClientError } from '@lib/errors/client';
import { useUserInfo } from '@domain/user/useUserInfo';
import { ExternalLink } from '../../../../../Clickables/ExternalLink/ExternalLink';
import { InternalLink } from '../../../../../Clickables/InternalLink/InternalLink';
import { Heading } from '../../../../../Heading/Heading';

import { BrandMenu } from './BrandMenu';

interface IProps {
  onExpandedChange: (value: boolean) => void;
}

export const SecondaryDropDownLinks = ({ onExpandedChange }: IProps) => {
  const { user } = useUserInfo();
  const router = useRouter();
  const { currentPage } = useAnalytics();

  const navigateTo = (path: string): void => {
    onExpandedChange(false);
    try {
      router.push(path);
    } catch (error) {
      reportMykissClientError(error);
    }
  };

  return (
    <div
      className="flex flex-col px-6 pt-4 sm:px-11 sm:pt-6 md:px-6 md:pt-4"
      data-testid="SecondaryDropDownLinks"
    >
      <Heading variant="xs" as="div" className="text-abyss m-0 mb-4 sm:mb-6 md:mb-4 md:text-base!">
        <InternalLink
          to={user?.isPremium ? '/pro/overview' : '/pro'}
          variant="textNone"
          className="text-pike-shade flex items-center"
          onClick={() => {
            onExpandedChange(false);
            trackEvent({
              name: 'mykiss_cta_button_clicked',
              properties: {
                type: 'pro',
                source: 'navigation',
                page: currentPage,
              },
            });
          }}
        >
          Fishbrain Pro
        </InternalLink>
      </Heading>
      <Heading variant="xs" as="div" className="text-abyss m-0 mb-4 sm:mb-6 md:mb-4 md:text-base!">
        <InternalLink
          to="/mission"
          variant="textNone"
          className="flex items-center"
          onClick={() => {
            onExpandedChange(false);
            trackNavigation({ path: 'mission', currentPage });
            trackEvent({
              name: 'mykiss_hamburger_clicked',
              properties: { action: 'navigate', source: currentPage },
            });
          }}
        >
          About Fishbrain
        </InternalLink>
      </Heading>
      <Heading variant="xs" as="div" className="text-abyss m-0 mb-4 sm:mb-6 md:mb-4 md:text-base!">
        <ExternalLink
          href="https://fishbrainhelp.zendesk.com/hc/en-us"
          variant="textNone"
          className="flex items-center"
          onClick={() => {
            trackNavigation({ path: 'support', currentPage });
          }}
        >
          Support
        </ExternalLink>
      </Heading>
      {!!user && <BrandMenu navigateTo={navigateTo} onExpandedChange={onExpandedChange} />}
    </div>
  );
};
